<template>
  <div class="home-page">
    <!-- 头部导航 - 使用公共组件 -->
    <Navbar />
    
    <!-- 主要内容区 -->
    <main class="main-content">
      <!-- Hero Banner 轮播图区域 -->
      <section class="hero-carousel">
        <el-carousel height="470px" :interval="8000" arrow="always">
          <!-- 轮播图1：专业检测服务 -->
          <el-carousel-item>
            <div class="hero-slide" :style="{backgroundImage: `url(${banners.banner1})`}">
              <div class="hero-overlay"></div>
              <div class="hero-container">
                <div class="hero-content">
                  <h1 class="hero-title">专业工业安全检测服务</h1>
                  <p class="hero-description">提供空气呼吸器、气体报警仪、气瓶等全方位检测解决方案，保障您的生产安全</p>
                  <el-button type="primary" size="large" class="hero-btn" @click="showContactDialog">立即咨询</el-button>
                </div>
              </div>
            </div>
          </el-carousel-item>
          
          <!-- 轮播图2：报告查询 -->
          <el-carousel-item>
            <div class="hero-slide" :style="{backgroundImage: `url(${banners.banner2})`}">
              <div class="hero-overlay"></div>
              <div class="hero-container">
                <div class="hero-content">
                  <h1 class="hero-title">便捷报告查询系统</h1>
                  <p class="hero-description">在线查询检测报告，随时随地获取报告详情，高效便捷，一键下载</p>
                  <el-button type="primary" size="large" class="hero-btn" @click="$router.push('/baogao')">查询报告</el-button>
                </div>
              </div>
            </div>
          </el-carousel-item>
          
          <!-- 轮播图3：企业文化 -->
          <el-carousel-item>
            <div class="hero-slide" :style="{backgroundImage: `url(${banners.banner3})`}">
              <div class="hero-overlay"></div>
              <div class="hero-container">
                <div class="hero-content">
                  <h1 class="hero-title">专业团队 · 匠心服务</h1>
                  <p class="hero-description">资深技术团队，严格质量把控，以专业精神铸就行业标杆，为客户创造价值</p>
                  <el-button type="primary" size="large" class="hero-btn">了解我们</el-button>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </section>

      <!-- 服务项目区域 -->
      <section class="services-section">
        <div class="section-container">
          <h2 class="section-title">我们的服务项目</h2>
          <div class="services-grid">
            <div class="service-card" @click="$router.push('/air-breathing-apparatus')" style="cursor: pointer;">
              <div class="service-icon">
                <i class="el-icon-cpu"></i>
              </div>
              <h3 class="service-name">空气呼吸器检测</h3>
              <p class="service-desc">全面检测呼吸器性能，确保紧急情况下的生命安全保障。</p>
            </div>
            
            <div class="service-card" @click="$router.push('/gas-alarm-detector')" style="cursor: pointer;">
              <div class="service-icon">
                <i class="el-icon-bell"></i>
              </div>
              <h3 class="service-name">气体报警仪检测</h3>
              <p class="service-desc">校准气体探测设备，预防有害气体泄漏带来的风险。</p>
            </div>
            
            <div class="service-card" @click="$router.push('/gas-cylinder-detection')" style="cursor: pointer;">
              <div class="service-icon">
                <i class="el-icon-box"></i>
              </div>
              <h3 class="service-name">气瓶检测</h3>
              <p class="service-desc">定期检验压力容器安全性，防止爆炸等安全事故的发生。</p>
            </div>
            
            <div class="service-card" @click="$router.push('/baogao')" style="cursor: pointer;">
              <div class="service-icon">
                <i class="el-icon-document"></i>
              </div>
              <h3 class="service-name">报告查询</h3>
              <p class="service-desc">在线获取权威检测报告，实时掌握设备安全状态。</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 关于我们区域 -->
      <section class="about-section">
        <div class="section-container">
          <h2 class="section-title">关于我们</h2>
          <div class="about-wrapper">
            <div class="about-image">
              <img src="@/assets/hj2.png" alt="关于慧安检测" class="about-img" />
            </div>
            <div class="about-content">
              <p class="about-text">陕西慧安和信检测有限公司成立于2017年08月，坐落于西安经济技术开发区，是经市场监督管理局依法批准的第三方检验检测机构，具有独立法人资格。</p>
              <p class="about-text">公司现开展的业务有空气呼吸器、气体检测报警仪及呼吸器用复合气瓶的检测。</p>
              <p class="about-text">公司以"科学、公正、专业、高效"的质量方针，凭借精密的仪器设备及精湛的技术团队，秉承"质量第一、用户至上"的服务理念，不断为客户提供优质、高效、满意的技术服务，多年来公司凭借专业的技术水平、一流的技术服务零差错率等优势获得了客户的一致好评。</p>
              <el-button type="primary" plain size="medium" class="about-btn" @click="$router.push('/about')">了解更多</el-button>
            </div>
          </div>
        </div>
      </section>
    </main>
    
    <!-- 底部区域 - 使用公共组件 -->
    <Footer />

    <!-- 联系咨询对话框 -->
    <el-dialog
      title="联系我们"
      :visible.sync="contactDialogVisible"
      :width="isMobile ? '85%' : '420px'"
      :class="{'contact-dialog-mobile': isMobile}"
      custom-class="contact-dialog"
      center>
      <div class="contact-dialog-content">
        <div class="contact-icon">
          <i class="el-icon-phone-outline"></i>
        </div>
        <h3 class="contact-title">咨询热线</h3>
        <div class="contact-phone">
          <a v-if="isMobile" :href="'tel:' + settings.contact_phone" class="phone-link-mobile">
            {{ settings.contact_phone || '加载中...' }}
          </a>
          <span v-else class="phone-text">{{ settings.contact_phone || '加载中...' }}</span>
        </div>
        <p class="contact-tips" v-if="isMobile">点击号码即可直接拨打</p>
        <p class="contact-tips" v-else>请拨打上方电话与我们联系</p>
        
        <div class="contact-info-extra">
          <div class="info-item" v-if="settings.contact_email">
            <i class="el-icon-message"></i>
            <span>{{ settings.contact_email }}</span>
          </div>
          <div class="info-item" v-if="settings.address">
            <i class="el-icon-location"></i>
            <span>{{ settings.address }}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="contactDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="copyPhone" v-if="!isMobile">
          <i class="el-icon-document-copy"></i> 复制号码
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import settingsMixin from '@/mixins/settingsMixin'

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer
  },
  mixins: [settingsMixin],
  data() {
    return {
      banners: {
        banner1: require('@/assets/kqhxqjc.png'),
        banner2: require('@/assets/banner2.jpg'),
        banner3: require('@/assets/banner3.jpg')
      },
      contactDialogVisible: false
    }
  },
  computed: {
    // 判断是否为移动设备
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768
    }
  },
  mounted() {
    // 加载网站设置（获取联系电话等信息）
    this.fetchSettings()
  },
  methods: {
    // 显示联系对话框
    showContactDialog() {
      this.contactDialogVisible = true
    },
    // 复制电话号码（PC端）
    copyPhone() {
      const phone = this.settings.contact_phone
      if (!phone) {
        this.$message.warning('电话号码未设置')
        return
      }
      
      // 创建临时输入框
      const input = document.createElement('input')
      input.value = phone
      document.body.appendChild(input)
      input.select()
      
      try {
        document.execCommand('copy')
        this.$message.success('电话号码已复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败，请手动复制')
      }
      
      document.body.removeChild(input)
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  background: #ffffff;
}

/* 主要内容区 */
.main-content {
  min-height: calc(100vh - 130px);
}

/* Hero Banner 轮播图区域 */
.hero-carousel {
  width: 100%;
  position: relative;
}

.hero-slide {
  width: 100%;
  height: 470px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  transform: translateZ(0);
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.1) 100%);
  z-index: 1;
}

.hero-container {
  max-width: 1200px;
  width: 100%;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}

.hero-content {
  text-align: center;
  color: white;
  animation: fadeInUp 0.8s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-title {
  font-size: 48px;
  font-weight: 700;
  margin: 0 0 24px 0;
  line-height: 1.3;
}

.hero-description {
  font-size: 18px;
  line-height: 1.8;
  margin: 0 0 40px 0;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.hero-btn {
  height: 50px;
  padding: 0 48px;
  font-size: 16px;
  border-radius: 25px;
}

/* Element UI 轮播图自定义样式 */
.hero-carousel >>> .el-carousel__container {
  height: 470px;
}

.hero-carousel >>> .el-carousel__arrow {
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  width: 48px;
  height: 48px;
  font-size: 18px;
}

.hero-carousel >>> .el-carousel__arrow:hover {
  background-color: rgba(24, 144, 255, 0.8);
}

.hero-carousel >>> .el-carousel__indicators {
  bottom: 30px;
}

.hero-carousel >>> .el-carousel__indicator {
  padding: 0;
}

.hero-carousel >>> .el-carousel__button {
  width: 40px;
  height: 4px;
  border-radius: 2px;
  background-color: rgba(255, 255, 255, 0.4);
  transition: all 0.3s;
}

.hero-carousel >>> .el-carousel__indicator.is-active .el-carousel__button {
  background-color: #ffffff;
  width: 50px;
}

/* 通用区域样式 */
.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-title {
  font-size: 36px;
  font-weight: 600;
  text-align: center;
  margin: 0 0 48px 0;
  color: #333333;
}

/* 服务项目区域 */
.services-section {
  padding: 60px 0;
  background: #ffffff;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.service-card {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 32px 24px;
  text-align: center;
  transition: all 0.3s;
  cursor: pointer;
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  border-color: #1890ff;
}

.service-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  background: linear-gradient(90deg, #1e3a8a 0%, #3b82f6 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.service-icon i {
  font-size: 32px;
  color: white;
}

.service-name {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #333333;
}

.service-desc {
  font-size: 14px;
  line-height: 1.8;
  color: #666666;
  margin: 0;
}

/* 关于我们区域 */
.about-section {
  padding: 60px 0;
  background: #ffffff;
}

.about-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.about-image {
  width: 100%;
  height: 400px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.about-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.about-image:hover .about-img {
  transform: scale(1.05);
}

.about-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.about-text {
  font-size: 16px;
  line-height: 2;
  color: #666666;
  margin: 0;
  text-align: justify;
}

.about-btn {
  align-self: flex-start;
  margin-top: 8px;
  height: 40px;
  padding: 0 32px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 992px) {
  .main-content {
    padding-top: 0;
  }
  
  .hero-title {
    font-size: 36px;
  }
  
  .hero-description {
    font-size: 16px;
  }
  
  .section-title {
    font-size: 28px;
  }
  
  .services-section,
  .about-section {
    padding: 45px 0;
  }
  
  .about-wrapper {
    gap: 48px;
  }
  
  .about-image {
    height: 340px;
  }
}

@media (max-width: 768px) {
  .main-content {
    padding-top: 0;
  }
  
  .hero-carousel >>> .el-carousel {
    height: 400px !important;
  }
  
  .hero-slide {
    height: 400px;
  }
  
  .hero-title {
    font-size: 28px;
  }
  
  .hero-description {
    font-size: 14px;
  }
  
  .hero-btn {
    height: 44px;
    padding: 0 32px;
    font-size: 14px;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .section-title {
    font-size: 24px;
    margin-bottom: 32px;
  }
  
  .services-section,
  .about-section {
    padding: 30px 0;
  }
  
  .about-wrapper {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  
  .about-image {
    height: 280px;
  }
  
  .about-text {
    font-size: 15px;
    line-height: 1.8;
  }
}

/* 联系对话框样式 */
.contact-dialog-content {
  text-align: center;
  padding: 10px 15px;
}

.contact-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
}

.contact-icon i {
  font-size: 35px;
  color: white;
}

.contact-title {
  font-size: 20px;
  color: #333;
  margin: 0 0 15px 0;
  font-weight: 600;
}

.contact-phone {
  margin: 15px 0;
}

.phone-link-mobile {
  font-size: 28px;
  font-weight: 700;
  color: #667eea;
  text-decoration: none;
  display: inline-block;
  padding: 12px 24px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-radius: 10px;
  border: 2px solid #667eea;
  transition: all 0.3s;
}

.phone-link-mobile:hover,
.phone-link-mobile:active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.phone-text {
  font-size: 28px;
  font-weight: 700;
  color: #667eea;
  letter-spacing: 1px;
}

.contact-tips {
  color: #999;
  font-size: 14px;
  margin: 15px 0;
}

.contact-info-extra {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.info-item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px 0;
  color: #666;
  font-size: 15px;
}

.info-item i {
  margin-right: 10px;
  font-size: 18px;
  color: #667eea;
}

/* 对话框底部按钮 */
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 15px;
}

/* 移动端对话框优化 */
@media (max-width: 768px) {
  .contact-dialog >>> .el-dialog {
    width: 85% !important;
    margin-top: 15vh !important;
  }
  
  .contact-phone {
    margin: 25px 0;
  }
  
  .phone-link-mobile {
    font-size: 28px;
    padding: 12px 25px;
  }
  
  .phone-text {
    font-size: 28px;
  }
  
  .contact-tips {
    font-size: 13px;
  }
}

/* PC端对话框宽度 */
@media (min-width: 769px) {
  .contact-dialog >>> .el-dialog {
    width: 420px !important;
  }
}
</style>

